import { type ComponentType } from 'react';
import { CustomerAutocomplete } from '../../CustomerAutocomplete';
import type { FilterControlProps } from '../types';

type Customer = { customerId: string; name: string };

/* CustomerAutocomplete is JavaScript whose props TypeScript infers as all required; this names the ones passed here. */
const Picker = CustomerAutocomplete as ComponentType<{
  value: Customer | null;
  onChangeValue: (next: Customer | null) => void;
  label?: string | undefined;
}>;

/** A CUSTOMER filter: the customer picker, labelled with the field's label; its value is the chosen customer or null. */
export function CustomerFilterControl({ field, value, setQuery }: FilterControlProps) {
  return (
    <div role="group" aria-label={field.label} className="flex w-full flex-col">
      <Picker label={field.label} value={value ?? null} onChangeValue={(next) => field.setField?.(next, setQuery, field)} />
    </div>
  );
}
